import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = { class: "conversation-information" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { for: "textField" }
const _hoisted_6 = { class: "login-info" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConversationIcon = _resolveComponent("ConversationIcon")
  const _component_NcTextField = _resolveComponent("NcTextField")
  const _component_Check = _resolveComponent("Check")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcModal = _resolveComponent("NcModal")

  return (_openBlock(), _createBlock(_component_NcModal, {
    "no-close": "",
    "close-on-click-outside": false,
    "label-id": $setup.dialogHeaderId,
    size: "small"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ConversationIcon, {
            item: $options.conversation,
            "hide-user-status": ""
          }, null, 8, ["item"]),
          _createElementVNode("h2", {
            id: $setup.dialogHeaderId,
            class: "nc-dialog-alike-header"
          }, _toDisplayString($options.conversationDisplayName), 9, _hoisted_3)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString($options.conversationDescription), 1),
        _createElementVNode("label", _hoisted_5, _toDisplayString($options.t('spreed', 'Enter your name')), 1),
        _createVNode(_component_NcTextField, {
          id: "textField",
          modelValue: $setup.guestUserName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.guestUserName) = $event)),
          placeholder: $options.t('spreed', 'Guest'),
          class: "username-form__input",
          "show-trailing-button": false,
          "label-outside": "",
          onKeydown: _withKeys($options.handleChooseUserName, ["enter"])
        }, null, 8, ["modelValue", "placeholder", "onKeydown"]),
        _createVNode(_component_NcButton, {
          class: "submit-button",
          variant: "primary",
          disabled: $options.invalidGuestUsername,
          onClick: $options.handleChooseUserName
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_Check, { size: 20 })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.t('spreed', 'Submit name and join')) + " ", 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "separator" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString($options.t('spreed', 'Do you already have an account?')), 1),
          _createVNode(_component_NcButton, {
            variant: "secondary",
            href: $options.getLoginUrl()
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.t('spreed', 'Log in')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["label-id"]))
}